export const colorPalette = [
  'transparent',
  '#FFFFFF',
  '#000000',
  '#333333',
  '#666666',
  '#999999',
  '#B2B2B2',
  '#BFBFBF',
  '#CCCCCC',
  '#D2BDD2',
  '#FCD3DE',
  '#FFBBB1',
  '#FFD9A9',
  '#FFEAAA',
  '#C5E6AD',
  '#94D4CA',
  '#BEE4F6',
  '#AFD7EF',
  '#B593B5',
  '#F8B6C7',
  '#FF9080',
  '#FFC175',
  '#FFDD73',
  '#9FD77A',
  '#4FB9A8',
  '#94D2F1',
  '#7EBCE5',
  '#864687',
  '#E36284',
  '#CE3038',
  '#F38B24',
  '#FFC13C',
  '#75B34B',
  '#00957D',
  '#26A8DC',
  '#007EB9',
];

export const colorPaletteBrand = ['#D6246E', '#C10F59', '#7833FF', '#5F29CC', '#212121', '#616161'];
